/**
 * Carousel Circles Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initCarouselCircles() {
        const blocks = document.querySelectorAll('.carousel-circles');
        
        blocks.forEach(block => {
            const circlesContainer = block.querySelector('.circles');
            const circles = circlesContainer ? Array.from(circlesContainer.querySelectorAll('.circle')) : [];
            const iconWrappers = circlesContainer ? Array.from(circlesContainer.querySelectorAll('.icon_wrapper')) : [];
            const icons = circlesContainer ? Array.from(circlesContainer.querySelectorAll('.icon_wrapper i')) : [];
            
            if (circles.length > 0) {
                // Find the parent carousel slide (optional)
                const parentSlide = block.closest('.carousel-slide');
                const isInCarousel = !!parentSlide;
                
                // Wait for GSAP to be available
                let retryCount = 0;
                const maxRetries = 50;
                let currentAnimation = null;
                
                function checkGSAP() {
                    retryCount++;
                    
                    let gsapLib = null;
                    
                    if (typeof gsap !== 'undefined') {
                        gsapLib = gsap;
                    } else if (typeof window.gsap !== 'undefined') {
                        gsapLib = window.gsap;
                    } else if (window.SOJ_GSAP_ANIMATIONS && window.SOJ_GSAP_ANIMATIONS.gsap) {
                        gsapLib = window.SOJ_GSAP_ANIMATIONS.gsap;
                    }
                    
                    if (gsapLib) {
                        // Declare animation state variables first
                        let isAnimating = false;
                        let animationTimeout = null;
                        
                        // Function to reset circles, icon_wrapper and icons to initial state
                        function resetAnimation() {
                            if (currentAnimation) {
                                currentAnimation.kill();
                                currentAnimation = null;
                            }
                            isAnimating = false;
                            if (animationTimeout) {
                                clearTimeout(animationTimeout);
                                animationTimeout = null;
                            }
                            // Only set properties if elements exist
                            if (circles.length > 0) {
                                gsapLib.set(circles, {
                                    opacity: 0,
                                    scale: 0,
                                    x: -50 // Start slightly to the left
                                });
                            }
                            if (iconWrappers.length > 0) {
                                gsapLib.set(iconWrappers, {
                                    opacity: 0,
                                    scale: 0,
                                    y: -40 // Start above the final position
                                });
                            }
                            if (icons.length > 0) {
                                gsapLib.set(icons, {
                                    opacity: 0,
                                    scale: 0
                                });
                            }
                        }
                        
                        // Set initial state - all circles hidden
                        resetAnimation();
                        
                        // Function to trigger animation
                        function triggerAnimation() {
                            // Prevent multiple simultaneous triggers
                            if (isAnimating) {
                                return;
                            }
                            
                            // Clear any pending animation
                            if (animationTimeout) {
                                clearTimeout(animationTimeout);
                                animationTimeout = null;
                            }
                            
                            // Verify elements exist in DOM
                            const validCircles = circles.filter(c => c && document.contains(c));
                            const validIconWrappers = iconWrappers.filter(i => i && document.contains(i));
                            const validIcons = icons.filter(i => i && document.contains(i));
                            
                            if (validCircles.length === 0 && validIconWrappers.length === 0) {
                                return;
                            }
                            
                            // Kill any existing animation
                            if (currentAnimation) {
                                currentAnimation.kill();
                                currentAnimation = null;
                            }
                            
                            // Reset to initial state first
                            resetAnimation();
                            
                            // Mark as animating
                            isAnimating = true;
                            
                            // Small delay to ensure reset is applied
                            animationTimeout = setTimeout(() => {
                                // Create timeline for synchronized animation
                                const tl = gsapLib.timeline({
                                    onComplete: () => {
                                        isAnimating = false;
                                        currentAnimation = null;
                                    }
                                });
                                
                                // Animate icon_wrapper with stagger (preserve -20px position)
                                if (validIconWrappers.length > 0) {
                                    tl.to(validIconWrappers, {
                                        opacity: 1,
                                        scale: 1,
                                        y: -20, // Animate to -20px to preserve original position
                                        duration: 1.5,
                                        ease: "back.out(1.7)",
                                        stagger: 0.15 // 150ms delay between each icon_wrapper
                                    }, 0); // Start at time 0
                                }
                                
                                // Animate icons with stagger (no rotation)
                                if (validIcons.length > 0) {
                                    tl.to(validIcons, {
                                        opacity: 1,
                                        scale: 1,
                                        duration: 1.2,
                                        ease: "back.out(1.7)",
                                        stagger: 0.15 // 150ms delay between each icon
                                    }, 0.4); // Start after icon_wrapper has animated (400ms delay)
                                }
                                
                                // Animate circles
                                if (validCircles.length > 0) {
                                    tl.to(validCircles, {
                                        opacity: 1,
                                        scale: 1,
                                        x: 0,
                                        duration: 2.5,
                                        ease: "back.out(1.7)",
                                        stagger: 0.2 // 200ms delay between each circle (left to right)
                                    }, 0.3); // Start after icons (300ms delay)
                                }
                                
                                currentAnimation = tl;
                            }, 100);
                        }
                        
                        if (isInCarousel) {
                            // Store trigger function on the block so carousel can call it
                            block._triggerCarouselCirclesAnimation = triggerAnimation;
                            block._resetCarouselCirclesAnimation = resetAnimation;
                            
                            let hasAnimated = false;
                            
                            // Function to check if slide is visible and trigger animation
                            const checkAndTrigger = () => {
                                const style = window.getComputedStyle(parentSlide);
                                const isVisible = parseFloat(style.opacity) === 1 && style.visibility !== 'hidden';
                                
                                if (isVisible && !hasAnimated && !isAnimating) {
                                    hasAnimated = true;
                                    triggerAnimation();
                                } else if (!isVisible && hasAnimated) {
                                    hasAnimated = false;
                                    resetAnimation();
                                }
                            };
                            
                            // Carousel mode: listen for slideActive event from carousel
                            const handleSlideActive = () => {
                                hasAnimated = false; // Reset flag to allow re-animation
                                // Use a longer delay to ensure slide transition is complete
                                setTimeout(() => {
                                    checkAndTrigger();
                                }, 300);
                            };
                            
                            const handleSlideReset = () => {
                                hasAnimated = false;
                                resetAnimation();
                            };
                            
                            parentSlide.addEventListener('slideActive', handleSlideActive);
                            parentSlide.addEventListener('slideReset', handleSlideReset);
                            
                            // Also listen on the wrapper in case events bubble
                            const wrapper = parentSlide.closest('.carousel-wrapper');
                            if (wrapper) {
                                wrapper.addEventListener('slideActive', handleSlideActive);
                                wrapper.addEventListener('slideReset', handleSlideReset);
                            }
                            
                            // Use MutationObserver to watch for style changes on the slide
                            const styleObserver = new MutationObserver(() => {
                                checkAndTrigger();
                            });
                            
                            // Observe the slide for style attribute changes
                            styleObserver.observe(parentSlide, {
                                attributes: true,
                                attributeFilter: ['style', 'class'],
                                subtree: false
                            });
                            
                            // Also use IntersectionObserver as a fallback to detect when block comes into view
                            if (typeof IntersectionObserver !== 'undefined') {
                                const intersectionObserver = new IntersectionObserver((entries) => {
                                    entries.forEach(entry => {
                                        if (entry.isIntersecting) {
                                            // Block is in viewport - check if slide is visible
                                            setTimeout(checkAndTrigger, 100);
                                        }
                                    });
                                }, {
                                    threshold: 0.1,
                                    rootMargin: '0px'
                                });
                                
                                intersectionObserver.observe(block);
                            }
                            
                            // Check immediately and also after delays to catch various initialization scenarios
                            checkAndTrigger();
                            setTimeout(checkAndTrigger, 500);
                            setTimeout(checkAndTrigger, 1000);
                            
                            // Periodic check as a last resort (runs for 3 seconds after initialization)
                            let periodicCheckCount = 0;
                            const maxPeriodicChecks = 6; // 3 seconds at 500ms intervals
                            const periodicInterval = setInterval(() => {
                                periodicCheckCount++;
                                checkAndTrigger();
                                
                                if (periodicCheckCount >= maxPeriodicChecks) {
                                    clearInterval(periodicInterval);
                                }
                            }, 500);
                        } else {
                            // Standalone mode: animate when block comes into view
                            
                            // Use IntersectionObserver for viewport detection
                            if (typeof IntersectionObserver !== 'undefined') {
                                const observer = new IntersectionObserver((entries) => {
                                    entries.forEach(entry => {
                                        if (entry.isIntersecting) {
                                            // Block is in view - trigger animation
                                            setTimeout(triggerAnimation, 100);
                                        } else {
                                            // Block left view - reset for next time
                                            resetAnimation();
                                        }
                                    });
                                }, {
                                    threshold: 0.3, // Trigger when 30% of the block is visible
                                    rootMargin: '0px 0px -50px 0px' // Start animation slightly before fully visible
                                });
                                
                                observer.observe(block);
                            } else {
                                // Fallback: animate immediately if no IntersectionObserver support
                                setTimeout(triggerAnimation, 500);
                            }
                        }
                        return;
                    }
                    
                    if (retryCount < maxRetries) {
                        setTimeout(checkGSAP, 100);
                    }
                }
                
                checkGSAP();
            }
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCarouselCircles);
    } else {
        initCarouselCircles();
    }
})();